'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSuiteLegalDisclaimerUrl } from 'pricing-pages-lib/utils/urls';
import { useSelector } from 'react-redux';
import { MARKETING, OPERATIONS, SALES, SERVICE, CMS } from 'self-service-api/constants/ProductLines';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import UILink from 'UIComponents/link/UILink';
import { BUNDLE_CARD } from '../../../constants/Tracking';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import SuiteTileCTAsContainer from '../../suite-page/SuiteTileCTAsContainer';
import SuiteViewAllFeatures from '../../suite-page/SuiteViewAllFeatures';
import CardLayout from './CardLayout';
import SkeletonLoadWrapper from '../../loading/SkeletonLoadWrapper';
import { hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import SuiteTermSelectorContainer from '../../suite-page/SuiteTermSelectorContainer';
import { CrmSuitePrice } from '../../suite-page/CrmSuiteTopSection/CrmSuitePrice';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { useValidatedCrmSuiteQueryParamTerm } from '../../../utils/stateUtils';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
const StyledContainer = styled.span.withConfig({
  displayName: "StarterCrmSuiteCard__StyledContainer",
  componentId: "sc-1wj0cxh-0"
})(["div:first-child{margin-top:0 !important;}div:nth-child(2){justify-content:center;}"]);

const StarterCrmSuiteCard = ({
  productLine
}) => {
  const currencyCode = useSelector(activeCurrencySelector);
  const {
    queryParamTerm,
    setQueryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel: STARTER
  });
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const includedMerch = [{
    iconSrc: ProductLinePageIcons[MARKETING],
    message: 'pricingPage.pages.crmSuite.MARKETING.STARTER'
  }, {
    iconSrc: ProductLinePageIcons[CMS],
    message: 'pricingPage.pages.crmSuite.CMS.STARTER'
  }, {
    iconSrc: ProductLinePageIcons[SALES],
    message: 'pricingPage.pages.crmSuite.SALES.STARTER'
  }, {
    iconSrc: ProductLinePageIcons[SERVICE],
    message: 'pricingPage.pages.crmSuite.SERVICE.STARTER'
  }, {
    iconSrc: ProductLinePageIcons[OPERATIONS],
    message: 'pricingPage.pages.crmSuite.OPERATIONS.STARTER'
  }];

  const handleLegalLinkClick = () => {
    getUsageTracker().track('externalLinkClick', {
      name: 'legal-stuff',
      url: getSuiteLegalDisclaimerUrl(),
      trackingSource: BUNDLE_CARD
    });
  };

  return /*#__PURE__*/_jsx(CardLayout, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.crmSuite.title.starter"
    }),
    descriptionSubtext: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "recommendedBundles.crmSuite.description"
      }), ' ', /*#__PURE__*/_jsx(UILink, {
        href: getSuiteLegalDisclaimerUrl(),
        external: true,
        onClick: handleLegalLinkClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crmSuite.details"
        })
      })]
    }),
    ctasComponent: /*#__PURE__*/_jsxs(StyledContainer, {
      children: [/*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [16, 23, 16],
        widths: [60, 70, 130],
        className: "flex-column align-end",
        Content: CrmSuitePrice,
        contentProps: {
          productLevel: STARTER,
          termOverride: queryParamTerm,
          wrapperStyle: {
            textAlign: 'center'
          }
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "m-y-3",
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !hasPricingAndPurchasingSucceeded,
          heights: [41],
          Content: SuiteTermSelectorContainer,
          contentProps: {
            productLevel: STARTER,
            onChange: newTerm => {
              setQueryParamTerm(newTerm);
            },
            queryParamTerm,
            trackingSource: BUNDLE_CARD
          }
        })
      }), /*#__PURE__*/_jsx(SuiteTileCTAsContainer, {
        productLevel: STARTER,
        trackingSource: BUNDLE_CARD,
        termOverride: queryParamTerm,
        sourceId: `pricing-${productLine.toLowerCase()}pagebundlecard`,
        hubsSignupProductOverride: "suitestarter"
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-3",
        children: /*#__PURE__*/_jsx(SuiteViewAllFeatures, {
          productLevel: STARTER,
          currencyCode: currencyCode
        })
      })]
    }),
    bizObjectives: ['recommendedBundles.crmSuite.businessObjectives.captureAndConvert', 'recommendedBundles.crmSuite.businessObjectives.streamlineOutreach', 'recommendedBundles.crmSuite.businessObjectives.organizeComms'],
    includedMerch: includedMerch
  });
};

StarterCrmSuiteCard.propTypes = {
  productLine: PropTypes.string.isRequired
};
export default StarterCrmSuiteCard;